// extracted by mini-css-extract-plugin
module.exports = {"formElement":"JobMaterialPropertiesStep_formElement__2HkH1"};